'use client';

import { Button } from '@shared/components/shadcn';
import { Verified } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../form-controls/MultistepForm/hooks/useMultistepForm';
import type { SuccessStepProps } from '../types';

function SuccessStep({ onClose, firstName, type = 'name' }: SuccessStepProps) {
  const t = useTranslations('my_account');
  const { isLastStep } = useMultistepForm();

  const handleButtonClick = () => {
    if (isLastStep) {
      onClose();
    }
  };

  const stepConfig = {
    name: {
      titleKey: 'profile.profile_info.name_edit.success_title',
      titleParams: { name: firstName || 'User' },
      descriptionKey: 'profile.profile_info.name_edit.success_description',
    },
    address: {
      titleKey: 'profile.profile_info.address_edit.success_title',
      titleParams: { name: firstName || 'User' },
      descriptionKey: 'profile.profile_info.address_edit.success_description',
    },
  } as const;

  const config = stepConfig[type] || stepConfig.name;

  return (
    <div className="flex flex-col flex-1 min-h-0 p-6 h-full gap-6" data-track-container="Identity Submitted">
      <Verified size="extra-extra-large" data-testid="verified-icon" />

      {/* Success message */}
      <div className="space-y-2">
        <h4>{t(config.titleKey, config.titleParams)}</h4>
        <p className="paragraph-explanatory text-muted-foreground">{t(config.descriptionKey)}</p>
      </div>

      {/* Done button */}
      <div className="mt-auto shrink-0 p-4">
        <Button onClick={handleButtonClick} className="w-full" data-track-name={'Done'}>
          {t('profile.profile_info.address_edit.done')}
        </Button>
      </div>
    </div>
  );
}

export { SuccessStep };
